export default __webpack_public_path__ + "static/Aime-Italic-949b994a761847b90d970284eb04890f.woff2";